import { connect } from 'react-redux'
import PupilHead from './pupil-head'
import { withRouter } from 'react-router'
import {
  getFetchRequest,
  getPupil
} from '../../../../stores/pupil/pupil.selectors'

const mapStateToProps = (state, { match }) => {
  const pupil = getPupil(state)
  const fetchRequest = getFetchRequest(state)
  return {
    showLoadingScreen: !pupil || fetchRequest.pending,
    showPupilHead:
      !!pupil && !fetchRequest.pending && !fetchRequest.requestError
  }
}

export default withRouter(connect(mapStateToProps)(PupilHead))
